// extracted by mini-css-extract-plugin
module.exports = {"blogCard":"Blogs_blogCard__3VUgP"};